var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileOtherInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 51,
    viewBox: "0 0 57 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9982 0H6.62654C2.96814 0 0 2.86968 0 6.40672V35.7709C0 39.3079 2.96814 42.1776 6.62654 42.1776H36.9982C40.6566 42.1776 43.6247 39.3079 43.6247 35.7709V6.40672C43.6247 2.86968 40.6566 0 36.9982 0Z",
    transform: "translate(13.0342 0.756714) rotate(6.2868)",
    fill: "#201F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62652 1.0438H36.9981C40.1134 1.0438 42.5808 3.47907 42.5808 6.40674V35.771C42.5808 38.6986 40.1134 41.1339 36.9981 41.1339H6.62652C3.51114 41.1339 1.0438 38.6986 1.0438 35.771V6.40674C1.0438 3.47907 3.51114 1.0438 6.62652 1.0438Z",
    transform: "translate(0.137451 8.32031) rotate(-3.48761)",
    fill: "white",
    stroke: "#201F1F",
    strokeWidth: 2.08761
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOtherInner);
export default __webpack_public_path__ + "static/media/file-other-inner.f6d16740ecbd1a6eac43d955f0d86137.svg";
export { ForwardRef as ReactComponent };